import React, { useEffect, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { styled } from "@mui/system";
import Seperator from "components/Seperator";
import {
  editActivityGroup,
  getProjectsByCountry,
  editActivityGroupDelete,
} from "../../../../services";
import { useSelector } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  ADD_EDIT_ACTIVITY,
  WAREHOUSE_PROJECT_UPLOAD,
} from "../../../../navigation/CONSTANTS";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";
import { DELETED } from "config/CONSTANTS";
import ConfirmDialog from "components/ConfirmDialog";
import Confirmation from "components/Confirmation";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import "../../../../components/styling/style.css";
import NoData from "utils/NoData";
const dateConfig = {
  format1: "dddd, MMM Do", // shows date like Monday, June 1st
  format2: "DD/MM", // shows date like 09/06
  format3: "DD/MM/YYYY", // day month year
  format4: "YYYY-MM-DDTHH:mm:ss", // custom time format for localTS specifically
  format5: "ddd, MMM DD", // eg. "Mon, Sep 07"
  format6: "YYYY-MM-DD",
  format7: "YYYY-MM-DDTHH:mm",
};

export default function ManageActivityGroups() {
  const StyledButton = styled(Button)({
    color:"#1b75bc",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "25px",
    borderRadius: "5px",
    ':hover':{
      backgroundColor:"#1b75bc",
      color:"#FFFFFF",
    }
  });
  const DeleteButton = styled(Button)({
    fontWeight: "bold",
    textAlign: "center",
    borderRadius: "5px",
    lineHeight: "20px",
    borderColor:"#FF0000",
    color:"#FF0000",
    backgroundColor:"#ffffff",
    ':hover':{
      backgroundColor: "#FF0000",
      color:"#ffffff",
      borderColor:"#ff0000"
    },
    '&.Mui-disabled':{
      color: "rgba(244, 67, 54, 0.5)",
      borderColor:"rgba(244, 67, 54, 0.5)"
    }
  })
  const history = useHistory();
  const { t } = useTranslation();
  const onClickAddActivity = () => {
    history.push(ADD_EDIT_ACTIVITY);
  };
  const onClickWareHouseProjectUpload = () => {
    history.push(WAREHOUSE_PROJECT_UPLOAD);
  };
  const [isLoading, setIsLoading] = useState(true);
  const dispath = useDispatch();
  const { manageActivityGroupFiltersData } = useSelector(
    (state) => state.appConfig
  );
  //console.log("------manageActivityGroupFiltersData-------",manageActivityGroupFiltersData);

  const [confirmationBox, setConfirmationBox] = useState({
    isOpen: false,
    title: t("pgReview.deleteWorkersDialog.delSuccessTitle"),
    subTitle: t("other.msgDeleteAGSuccessMsg"),
  });
  const [confirmDialogDel, setConfirmDialogDel] = useState({
    isOpen: false,
    title: "other.titleDeleteActivityGroup",
    subTitle: "pgReview.deleteWorkersDialog.subTitle",
  });

  const [selectedActGrps, setSelectedActGrps] = useState([]);
  const [disableDeleteBtn, setDisableDeleteBtn] = useState(true);
  const [loading, setLoading] = React.useState(true);
  const deleteActivityGrp = (act) => {
    act = {
      ...act,
      isDeleted: true,
      isActive: false,
      actionTS: new Date().toISOString(),
      actionBy: user.workerId,
      actionType: DELETED,
    };
    console.log("Delete activity group=====", act);
    editActivityGroup(act.id, act)
      .then((result) => {
        setConfirmDialogDel({ ...confirmDialogDel, isOpen: false });
        if (result) {
          setConfirmationBox({ ...confirmationBox, isOpen: true });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const deleteActivityGrpDel = (act) => {
      setDisableDeleteBtn(true);
    act = act.map(activityGroup =>{
      let editedActivity =  {
        ...activityGroup,
        isDeleted: true,
        isActive: false,
        actionTS: new Date().toISOString(),
        actionBy: user.workerId,
        actionType: DELETED,
      };
      return editedActivity;
    })
    console.log("Delete activity group=====", act);
    editActivityGroupDelete(act, user.country)
      .then((result) => {
        setDisableDeleteBtn(true);
        setSelectedActGrps([]);
        setConfirmDialogDel({ ...confirmDialogDel, isOpen: false });
        if (result) {
          setConfirmationBox({ ...confirmationBox, isOpen: true });
        }
      })
      .catch((error) => {
        setDisableDeleteBtn(false);
        setConfirmDialogDel({ ...confirmDialogDel, isOpen: false });
        console.log(error);
      });
  };
  const deleteDone = () => {
    reloadList();
    setConfirmationBox({ ...confirmationBox, isOpen: false });
    table.resetRowSelection();
  };
  const [updateList, toggleUpdateList] = useState(true); // use this as useEffect dependency to update the list to latest.
  const reloadList = () => {
    toggleUpdateList(!updateList);
  };

  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );

  const [val, setVal] = useState([]);
  const columns = [
    {
      accessorKey: "name",
      size: 50,
      header: properCase(t("other.lblActivityName")),
      filter: true,
      filterList: manageActivityGroupFiltersData[0].length
        ? manageActivityGroupFiltersData[0]
        : null,
      Cell: ({ renderedCellValue, row }) => {
        let data = val[row.index];
        const link = (
          <Link
            style={{ textDecoration: "none", color: "#1b75bc" }}
            to={{
              pathname: ADD_EDIT_ACTIVITY,
              state: {
                id: data.id,
                data: data,
                mode: "edit",
              },
            }}
          >
            {renderedCellValue}
          </Link>
        );
        return link;
      },
    },
    {
      accessorKey: "activityGroup",
      header: properCase(t("pgPunch.lblActivityGroup")),
      size: 50,
      display: true,
      filter: true,
      filterList: manageActivityGroupFiltersData[1].length
        ? manageActivityGroupFiltersData[1]
        : null,
      Cell: ({ row }) => {
        let v = row.original.activityGroup;
        if (v) {
          if (v.toUpperCase() === "TRANSACTIONAL") {
            return properCase(t("pgHome.reportlabel2Transcational"));
          } else if (v.toUpperCase() === "PROJECT") {
            return properCase(t("pgHome.reprotlabel3Project"));
          } else if (v.toUpperCase() === "NON-TRANSACTIONAL") {
            return properCase(t("pgHome.reportlabel1Non-Transactional"));
          } else if (v.toUpperCase() === "LEAVE") {
            return properCase(t("other.lblLeave"));
          } else if (v.toUpperCase() === "MEAL") {
            return properCase(t("other.tlMeal"));
          } else if (v.toUpperCase() === "BUILDING MOVES") {
            return properCase(t("other.tlbuildingmoves"));
          }
        } else {
          return "NA";
        }
      },
    },
    {
      accessorKey: "managerEmail",
      header: properCase(t("other.tableManagerEmail")),
      display: true,
      filter: true,
      filterList: manageActivityGroupFiltersData[2].length
        ? manageActivityGroupFiltersData[2]
        : null,
      Cell: ({ row }) => {
        let v = row.original.managerEmail;
        return v ? v : "NA";
      },
    },
    {
      accessorKey: "startTS",
      header: properCase(t("pgReview.tableHeads.startDate")),
      display: true,
      filter: true,
      size: 50,
      filterList:
        manageActivityGroupFiltersData[3] &&
        manageActivityGroupFiltersData[3].length
          ? manageActivityGroupFiltersData[3]
          : null,
      Cell: ({ row }) => {
        let v = row.original.startTS;
        return v === undefined || v === null
          ? "NA"
          : moment(v).format(dateConfig.format3);
      },
    },
    {
      accessorKey: "endTS",
      header: properCase(t("pgReview.tableHeads.endDate")),
      display: true,
      filter: true,
      size: 50,
      filterList:
        manageActivityGroupFiltersData[4] &&
        manageActivityGroupFiltersData[4].length
          ? manageActivityGroupFiltersData[4]
          : null,
      Cell: ({ row }) => {
        let v = row.original.endTS;
        return v === undefined || v === null
          ? "NA"
          : moment(v).format(dateConfig.format3);
      },
    },
    {
      accessorKey: "isActive",
      header: properCase(t("other.tableActive")),
      display: true,
      filter: true,
      size: 50,
      filterList:
        manageActivityGroupFiltersData[5] &&
        manageActivityGroupFiltersData[5].length
          ? manageActivityGroupFiltersData[5]
          : null,
      Cell:({renderedCellValue, row}) =>{
          return renderedCellValue        
      },
    },
    {
      accessorKey: "isJobRoleRestricted",
      header: t("other.lblJobRoleRestricted"),
      display: true,
      size: 50,
      filter: true,
      filterList:
        manageActivityGroupFiltersData[6] &&
        manageActivityGroupFiltersData[6].length
          ? manageActivityGroupFiltersData[6]
          : null,
      Cell:({renderedCellValue, row}) =>{
          return renderedCellValue    
      },
    },
    {
      accessorKey: "isDistrictRestricted",
      header: t("other.isDistrictRestricted"),
      display: true,
      size: 50,
      filter: true,
      filterList:
        manageActivityGroupFiltersData[7] &&
        manageActivityGroupFiltersData[7].length
          ? manageActivityGroupFiltersData[7]
          : null,
      Cell:({renderedCellValue, row}) =>{
          return renderedCellValue     
      },
    },
    {
      accessorKey: "restrictedDistricts",
      header: t("other.lblRestrictedDistrict"),
      display: true,
      filter: true,
      enableColumnDragging: false,
      size: 70,
      filterList:
        manageActivityGroupFiltersData[8] &&
        manageActivityGroupFiltersData[8].length
          ? manageActivityGroupFiltersData[8]
          : null,
      Cell: ({ row }) => {
        // console.log('v:', v);
        let v = row.original.restrictedDistricts;
        return v && v.length > 0 ? (
          <>
            {v.map((element) => (
              <>
                <div>{element}</div>
              </>
            ))}
          </>
        ) : (
          "NA"
        );
      },
    },
  ];

  useEffect(() => {
    setIsLoading(true);
    getProjectsByCountry(user.country).then((querySnapshot) => {
      console.log("Queries: ", JSON.stringify(querySnapshot));

      querySnapshot = querySnapshot.sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      );

      const formattedActivity = querySnapshot.map((activity) =>{
        if(activity?.isJobRoleRestricted){
          activity.isJobRoleRestricted = properCase(t("pgReview.tableStaticText.yes"))
        }
        else{
          activity.isJobRoleRestricted = properCase(t("pgReview.tableStaticText.no"))
        }

        if(activity?.isDistrictRestricted){
          activity.isDistrictRestricted = properCase(t("pgReview.tableStaticText.yes"))
        }
        else{
          activity.isDistrictRestricted = properCase(t("pgReview.tableStaticText.no"))
        }

        if(activity?.isActive){
          activity.isActive = properCase(t("pgReview.tableStaticText.yes"))
        }
        else{
          activity.isActive = properCase(t("pgReview.tableStaticText.no"))
        }

        return activity;
      })
      setVal(formattedActivity);

      setIsLoading(false);
    });
  }, [user, updateList]);

  const handleDelete = (selectedRows) =>{
    if(selectedRows.length > 0){
        setConfirmDialogDel({
          title: "other.titleDeleteActivityGroup",
          subTitle:
            t("pgReview.deleteWorkersDialog.subTitle") +

            " ?",
          isOpen: true,
          onConfirm: () => {
            deleteActivityGrpDel(selectedRows);
          },
        })
     }
  }

  const table = useMaterialReactTable({
    columns,
    data: val,
    localization:{
      noRecordsToDisplay: <NoData/>,
      noResultsFound: <NoData/>
    },
    state:{
      isLoading: isLoading,
      showProgressBars: isLoading
    },
    muiCircularProgressProps:{
      sx:{
        ".MuiCircularProgress-circle":{
          transition:'none'
        }
      },
      variant: 'determinate'
    },
    muiSkeletonProps:{
      animation:'wave',
      height: 20
    },
    getRowId: (row) => console.log("RowData", row.original),
    enableSelectAll: true,
    enablePagination: true,
    enableGrouping: true,
    enableColumnPinning: true,
    enableStickyHeader: true,
    enableRowSelection: true,
    muiPaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      showRowsPerPage: true,
    },
    initialState: {
      density: "compact",
      pagination: {
        pageSize: 50,
      },
    },
    muiTableContainerProps: {
      sx: {
        minHeight: `calc(100vh - 350px)`,
        // he: `calc(100vh - 320px)`,
        maxHeight: `calc(100vh - 350px)`,
        //  maxHeight : "100%"
      },
    },
    muiTableHeadCellProps:{
      align: 'left',
    },
    muiTableBodyCellProps:{
      align: 'left'
    },
    renderTopToolbarCustomActions: ({ table }) => {
      const handleDeleteWrap = () => {
      const selectedRows =   table.getSelectedRowModel().flatRows.map((row) => row.original);
      console.log("rowsData", selectedRows);
      handleDelete(selectedRows);
      };
      return (
        <Grid
          container
          style={{
            gap: "20px",
            alignItems: "flex-end",
            margin: "0 20px",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" sx={{color: "#58595B"}}> {properCase(t("other.titleManageActivityGroup"))}</Typography>
          <Grid item style={{ display: "inline-flex", gap: "30px" }}>
            <span style={{cursor: "not-allowed"}}>
            <DeleteButton
              variant="outlined"
              onClick={handleDeleteWrap}
              disabled={!(table.getIsSomeRowsSelected() || table.getIsAllPageRowsSelected())}
            >
              {properCase(t("pgReview.tableStaticText.btnDelete"))}
            </DeleteButton>
            </span>
            <ConfirmDialog
              confirmDialog={confirmDialogDel}
              setConfirmDialog={setConfirmDialogDel}
            />
            <Confirmation
              confirmationMsg={confirmationBox.isOpen}
              closeModalConfirmationMsg={deleteDone}
              confirmationMsgText={confirmationBox.subTitle}
              confirmationTitleText={confirmationBox.title}
            />
          </Grid>
        </Grid>
      );
    },
  });
  return (
        <>
            <Grid container display="flex" justifyContent="flex-end">
              <Grid item>
                <StyledButton
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: 10 }}
                  onClick={onClickWareHouseProjectUpload}
                  // startIcon={<Add />}
                >
                  {t("other.lblWarehouseProjectUpload")}
                </StyledButton>
              </Grid>
              <Grid item>
                <StyledButton
                  variant="outlined"
                  color="primary"
                  onClick={onClickAddActivity}
                  startIcon={<AddIcon/>}
                >
                  {t("pgPunch.tlAddPunch")}
                </StyledButton>
              </Grid>
            </Grid>
            <Seperator />
            <MaterialReactTable table={table} />
        </>
  );
}
